import { Provider } from '@angular/core';

import { ApolloQueryService } from './apollo/apollo-query.service';
import { AuthService, LoginService, OAuthFlowService } from './auth';
import { BeaconService } from './beacon';
import { BrowserStorageService } from './browser-storage';
import { PackageMediaRulesService } from './businesspackage';
import { ClipboardService } from './clipboard';
import { ConfirmPromptService } from './confirm-prompt';
import { ConsentService } from './consent';
import { DownloadUrlsService } from './download-urls';
import { ErrorService } from './error';
import { EventProfileState } from './event';
import { GoogleAnalyticsService } from './google-analytics';
import { LandingService } from './landing';
import { LanguageService } from './language';
import { LicencesService } from './licence';
import { LocationService } from './location';
import { MaintenanceService } from './maintenance';
import { MarketingScriptsService } from './marketing-scripts';
import { MetaInfoService } from './meta-info';
import { NavbarService } from './navbar';
import { NavigationService } from './navigation';
import { NotificationsService } from './notifications';
import { PaymentService } from './payment';
import { PeriodService } from './period';
import { PointOfSaleProfileState } from './point-of-sale';
import { QueryParamsService } from './query-params';
import { StorageService } from './storage';
import { SuperadminService } from './superadmin';
import { TrackingService } from './tracking';
import { UnsavedChangesPromptService } from './unsaved-changes-prompt';
import { UserProfileState } from './user';
import { NewUserService } from './user_new';
import { UsergroupContext, UsergroupService } from './usergroup';
import { ValidatorsService } from './validators';

import { UsergroupProfileService } from 'app/profile/usergroup/services';

export function provideServices(): Provider[] {
    return [
        ApolloQueryService,
        AuthService,
        BeaconService,
        BrowserStorageService,
        ConfirmPromptService,
        ClipboardService,
        ConsentService,
        DownloadUrlsService,
        ErrorService,
        EventProfileState,
        GoogleAnalyticsService,
        LanguageService,
        LandingService,
        LicencesService,
        LocationService,
        LoginService,
        MaintenanceService,
        MarketingScriptsService,
        MetaInfoService,
        NavbarService,
        NavigationService,
        NotificationsService,
        OAuthFlowService,
        PackageMediaRulesService,
        PaymentService,
        PeriodService,
        PointOfSaleProfileState,
        QueryParamsService,
        StorageService,
        SuperadminService,
        TrackingService,
        UnsavedChangesPromptService,
        UsergroupService,
        UsergroupContext,
        UserProfileState,
        NewUserService,
        ValidatorsService,
        ApolloQueryService,
        GoogleAnalyticsService,
        UsergroupProfileService,
    ];
}
